export const isAndroid = () => (/Android/i.test(navigator.userAgent) ? true : false);
export const isApple = () => (/iPhone|iPad|Macintosh/i.test(navigator.userAgent) ? true : false);
